import React, { createContext } from 'react'
import useSearch from '../hooks/useSearch'

export const SearchContext = createContext({
  isSearchMobileActive: false,
  setIsSearchMobileActive: isActive => isActive,
  isVisible: false,
  setIsVisible: isVisible => isVisible,
  query: '',
  result: [],
  onChangeQuerySearch: event => event,
})

const SearchContextProvider = props => {
  const { isSearchMobileActive, setIsSearchMobileActive, isVisible, query, result, setIsVisible, onChangeQuerySearch } = useSearch()

  return (
    <SearchContext.Provider
      value={{
        isSearchMobileActive,
        setIsSearchMobileActive,
        isVisible,
        setIsVisible,
        query,
        result,
        onChangeQuerySearch,
      }}
    >
      {props.children}
    </SearchContext.Provider>
  )
}

export default SearchContextProvider
